<template>
  <el-header class="common-header">
    <div class="Herder-top">
      <div class="Her-wel">欢迎您登录世界至德！！</div>
      <div class="Her-but" v-if="!isdl">
        <router-link to="/register" class="Her-reg">注册</router-link>
        <router-link to="/login" class="Her-dl">登录</router-link>
      </div>
      <div class="Her-gren" v-if="isdl">
        <router-link to="/pernews">
          <span>个人中心</span>
          <img src="../../public/images/grzx.png">
        </router-link>
      </div>
    </div>

    <div class="admin-header">
      <div class="logo">
        <img class="admin-logo" src="../../public/images/logo.png">
        <div class="admin-text">
          <span>世界至德</span>
          <i>GEE TUCK WORLD</i>
        </div>
      </div>

      <div class="label">
        <router-link target="_blank" to="/" :class="{ active: isActive('/') }">首页</router-link>
        <router-link target="_blank" to="/ftime" :class="{ active: isActive('/ftime') || isActive('/ftimeinfo') }">第一时间</router-link>
        <router-link target="_blank" :to="{path:'/whole',query:{tab: undefined}}" :class="{ active: isActive('/wholelw') || isActive('/whole') || isActive('/wholeinfo')  }">天下文章</router-link>
        <router-link target="_blank" :to="{path:'/spandaut',query:{tab: undefined}}" :class="{ active: isActive('/spandaut') || isActive('/spandautinfo') }">人物春秋</router-link>
        <router-link target="_blank" :to="{path:'/strait',query:{tab: undefined}}" :class="{ active: isActive('/strait') || isActive('/straitinfo') }">台海两岸</router-link>
        <router-link target="_blank" to="/memorial" :class="{ active: isActive('/memorial') || isActive('/memorialext') || isActive('/memorialwith') }">至德纪念堂</router-link>
        <router-link target="_blank" to="/liaison" :class="{ active: isActive('/liaison') || isActive('/liaisoninfo') }">联络联谊</router-link>
        <router-link target="_blank" :to="{path:'/economic',query:{tab: undefined}}" :class="{ active: isActive('/economic') || isActive('/enterinfo') || isActive('/econinfo') }">至德经济</router-link>
        <router-link target="_blank" to="/about" :class="{ active: isActive('/about') }">关于我们</router-link>
      </div>
    </div>
  </el-header>

  
</template>

<script>
  export default {
    name: 'AllHeader',
    data(){
        return{
          isdl: false   //是否登录
        }
    },
    created(){
      if(localStorage.pctoken){
        this.isdl = true
      }else{
        this.isdl = false
      }
    },
    methods:{
      isActive(routePath) {
        return this.$route.path === routePath;
      }
    },
  }
</script>

<style scoped>
  .common-header {
    position: fixed;
    top: 0;
    width: 100%;
    height: 104px !important;
    z-index: 99; /* 确保头部在其他内容之上 */
  }
  .Herder-top{
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #F2F2F2;
    height: 40px;
    padding: 0 30px;
  }
  .Her-wel{
    font-weight: 400;
    font-size: 14px;
    color: #999999;
  }
  .Her-but{
    display: flex;
  }
  .Her-reg{
    width: 64px;
    height: 28px;
    background: #D8D8D8;
    border-radius: 14px;
    font-weight: 400;
    font-size: 14px;
    color: #333333;
    text-align: center;
    line-height: 28px;
  }
  .Her-dl{
    width: 64px;
    height: 28px;
    background: linear-gradient( 139deg, #ED403C 0%, #D71E1C 100%);
    border-radius: 14px;
    font-weight: 400;
    font-size: 14px;
    color: #fff;
    text-align: center;
    line-height: 28px;
    margin-left: 10px;
  }
  .Her-gren a{
    display: block;
    display: flex;
    align-items: center;
  }
  .Her-gren span{
    font-weight: 400;
    font-size: 14px;
    color: #666666;
    background: #F2F2F2;
    margin-right: 6px;
  }
  .Her-gren img{
    width: 22px;
    height: 22px;
  }

  .admin-header{
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #fff;
    height: 64px;
    padding: 0 30px;
    z-index: 1;
  }
  .logo{
    display: flex;
  }
  .admin-logo{
    width: 43px;
    height: 48px;
  }
  .admin-logo img{
    width: 43px;
    height: 48px;
  }
  .admin-text{
    margin-left: 15px;
  }
  .admin-text span{
    display: block;
    font-weight: bold;
    font-size: 20px;
    color: #333333;
    font-family: MicrosoftYaHei, MicrosoftYaHei;
  }
  .admin-text i{
    font-family: ArialMT;
    font-size: 14px;
    color: #999999;
    font-style: normal;
  }
  .label a{
    font-weight: 400;
    font-size: 18px;
    color: #333333;
    margin: 0 20px;
    padding-bottom: 21px;
  }
  .label a:hover{
    background: url(../../public/images/hover.png) center bottom no-repeat;
    background-size: 48px 4px;
  }
  .active{
    background: url(../../public/images/hover.png) center bottom no-repeat;
    background-size: 48px 4px;
  }
</style>
